import { Helmet } from 'react-helmet-async';

const ServiceSchema = ({
  service = {
    name: '',
    description: '',
    url: '',
    serviceType: 'Professional Service',
    areaServed: ['Minnesota', 'Minneapolis', 'Saint Paul']
  }
}) => {
  if (!service.name) {
    return null;
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": service.name,
    "description": service.description,
    "url": service.url || 'https://cititekpro.com',
    "serviceType": service.serviceType,
    "provider": {
      "@type": "Organization",
      "@id": "https://cititekpro.com/#organization",
      "name": "CitiTekPro",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2910 Pillsbury Ave, Suite 31",
        "addressLocality": "Minneapolis",
        "addressRegion": "MN",
        "postalCode": "55408",
        "addressCountry": "US"
      }
    },
    "areaServed": service.areaServed.map(area => ({
      "@type": area.toLowerCase().includes('minnesota') ? 'State' : 'City',
      "name": area
    })),
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceUrl": service.url || 'https://cititekpro.com',
      "availableLanguage": {
        "@type": "Language",
        "name": "English"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ServiceSchema;
